import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { pressActionEffect } from '@styles/mixin';
import { ReactNode } from 'react';

interface Props {
    icon: ReactNode;
    label: string;
    isSelected?: boolean;
    onClick: () => void;
}

/** 결제 수단 한 줄 (아이콘 + 이름) */
function MethodItem({
    icon, label, isSelected, onClick,
}:Props) {
    return (
        <Row type='button'
            aria-label='payment-method'
            data-name={label}
            data-selected={isSelected}
            onClick={onClick}>
            {icon}
            <Text fontWeight='medium' color={colors.textPrimary}>
                {label}
            </Text>
        </Row>
    );
}

const Row = styled.button`
    align-items: center;
    background-color: var(--color-background-pure);
    border: 1px solid var(--color-border-default);
    border-radius: var(--radius-sm);
    column-gap: var(--spacing-2);
    display: flex;
    flex-shrink: 0;
    height: 52px;
    overflow: hidden;
    padding: var(--spacing-1-5) var(--spacing-4);
    width: 100%;
    ${pressActionEffect}

    &[data-selected="true"] {
        background-color: var(--color-background-base);
        border-color: var(--color-border-accent);
    }
`;

export default MethodItem;
